import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-avatar",
  imports: [CommonModule],
  templateUrl: "./avatar.component.html",
  styleUrl: "./avatar.component.scss",
})
export class AvatarComponent {
  @Input() name: string = "";
  @Input() size: "xsmall" | "small" | "large" = "small";
  @Input() variant: "primary" | "secondary" = "primary";

  protected getInitials(name: string): string {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .slice(0, 2)
      .join("");
  }
}
